// Quick Regen API schemas — 19BJ Session 2.
//
// Quick Regen is the sync counterpart to POST /ingest/regenerate (async).
// It calls runRegenCore() directly in the Worker handler rather than spawning
// a Cloudflare Workflow. The response returns the full result synchronously
// (within ~30s), suitable for small-scope operations (≤5 items, ≤3 concepts,
// 1 case, or delete).
//
// Shared schema location so the web client can import it for API validation.
import { z } from 'zod';
import { RegenActionSchema } from '../schemas/regen-action.js';
// Re-use the constraint definitions from v4.ts (not exported individually).
const CourseId = z.string().regex(/^[a-z][a-z0-9_-]*$/).max(64);
const AnonId = z.string().min(1).max(128);
export const QuickRegenRequestSchema = z.object({
    courseId: CourseId,
    anonId: AnonId,
    action: RegenActionSchema,
});
export const QuickRegenResponseSchema = z.object({
    regenId: z.string(),
    items: z.array(z.unknown()),
    beforeSnapshot: z.array(z.unknown()),
    diffSummary: z.object({
        addedCount: z.number(),
        removedCount: z.number(),
        replacedCount: z.number(),
    }),
    cost: z.object({
        tokensIn: z.number(),
        tokensOut: z.number(),
        costRmbEstimate: z.number(),
    }),
});
//# sourceMappingURL=quick-regen.js.map